// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function PasteAsSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <iframe width="100%"
            src="https://www.youtube.com/embed/HKwW5kNBqYM?autoplay=1&mute=0&loop=1&playlist=HKwW5kNBqYM"
            title="Paste as demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen></iframe>
      </div>
      <div className="feature-header">
        <div className="feature-category">Paste as</div>
        <h2 className="slide-title">Turn clipboard contents into files</h2>
        <p className="slide-text">
          Copied an image or text or both? Right-click in any folder and choose Paste as to save contents
          straight to disk as actual files.
        </p>
      </div>
    </div>
  )
}

export default PasteAsSlide
